import {
  USER_LOADED,
  USER_LOADING,
  // AUTH_ERROR,
  LOGIN_SUCCESS,
  REGISTER_SUCCESS,
  // LOGIN_FAIL,
  LOGOUT_SUCCESS,
  REGISTER_FAIL,
  REGISTER_NOTIFICATION,
  FIRST_CONNECTION,
  LOGIN_NOTIFICATION,
  REGISTER_ERROR,
  LOGIN_ERROR,
  RESET_AUTH_USER,
  ACCEPT_COOKIES,
  RESET_PWD_USER,
  REMOVE_GREETINGS,
  USER_PASSWORD,
  CONNECT_FREE,
  MANUAL_LOGIN,
} from "../actions/types";

import { syncPendingSessionsOnStartup } from "../components/analyticsBackend/BackendSyncAgent";

let tokenIni = {};
let acceptCookiesIni = null;

try {
  tokenIni = localStorage.getItem("token");
} catch (e) {
  console.log("localstorage error", e);
}

try {
  acceptCookiesIni = JSON.parse(localStorage.getItem("acceptCookies"));

  if (acceptCookiesIni === true) {
    window["ga-disable-G-218QT8EDCS"] = false;
  }
} catch (e) {
  console.log("localstorage error", e);
}

const initialState = {
  token: tokenIni,
  isAuthenticated: null,
  // isLoading: false,
  authError: "",
  authNotification: "",
  loginTimestamp: Date.now(),
  acceptCookies: acceptCookiesIni,
  greetings: false,
  tokenType: "",
  // user: !localStorage.getItem("user")
  //   ? userIni
  //   : JSON.parse(localStorage.getItem("user")),
};

export default function (state = initialState, action) {
  switch (action.type) {
    case RESET_PWD_USER:
      return {
        ...state,
        authNotification: action.payload.msg,
      };
    case ACCEPT_COOKIES:
      localStorage.setItem("acceptCookies", JSON.stringify(action.payload));
      // localStorage.setItem("user", JSON.stringify(action.payload.user));
      return {
        ...state,
        acceptCookies: action.payload, // in payload user and token
      };
    case LOGIN_NOTIFICATION:
    case REGISTER_NOTIFICATION:
      return {
        ...state,
        authNotification: action.payload,
      };

    case REGISTER_SUCCESS:
      if (action.payload) {
        if (action.payload.token) {
          localStorage.setItem("isAuthenticated", true);
          localStorage.setItem("token", action.payload.token);

          return {
            ...state,
            token: action.payload.token, // in payload user and token
            isAuthenticated: true,
            loginTimestamp: Date.now(),
            greetings: true,
            tokenType: "",
            // isLoading: false,
            // authError: false,
            // errMessage: "",
          };
        } else {
          return { ...state };
        }
      } else {
        return { ...state };
      }

    case LOGIN_ERROR:
    case REGISTER_ERROR:
      return {
        ...state,
        authError: action.payload,
      };
    case FIRST_CONNECTION:
      let auth = localStorage.getItem("isAuthenticated");
      // let formattedAuth = typeof auth === "string" ? JSON.parse(auth) : null;
      // formattedAuth = formattedAuth ? true : false;

      let formattedAuth = false;
      if (auth === "true") {
        formattedAuth = true;
      }
      //   "formattedAuth",
      //   typeof localStorage.getItem("isAuthenticated"),
      //   formattedAuth
      // );
      return {
        ...state,
        isAuthenticated: formattedAuth,
      };
    case USER_LOADING:
      return {
        ...state,
        // isLoading: true,
      };
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        // isLoading: false,
        user: action.payload,
      };
    case REMOVE_GREETINGS:
      return {
        ...state,
        greetings: false,
      };

    case USER_PASSWORD:
      localStorage.setItem("token", action.payload.token);
      // const ws = useContext(WebSocketContext);
      // ws.setConnected(true);
      // localStorage.setItem("user", JSON.stringify(action.payload.user));

      if (action.payload.token) {
        return {
          ...state,
          token: action.payload.token,
          loginTimestamp: Date.now(),
          // isLoading: false,
          // authError: false,
          // errMessage: "",
        };
      } else {
        return {
          ...state,
        };
      }
    case MANUAL_LOGIN:
      localStorage.setItem("token", action.payload.token);
      return {
        ...state,
        token: action.payload.token,
        tokenType: action.payload.tokenType,
      };
    case LOGIN_SUCCESS:
      // break;
      localStorage.setItem("isAuthenticated", true);
      localStorage.setItem("token", action.payload.token);

      // const ws = useContext(WebSocketContext);
      // ws.setConnected(true);
      // localStorage.setItem("user", JSON.stringify(action.payload.user));

      syncPendingSessionsOnStartup();
      return {
        ...state,
        token: action.payload.token, // in payload user and token
        isAuthenticated: true,
        loginTimestamp: Date.now(),
        greetings: true,
        tokenType: "",
        // isLoading: false,
        // authError: false,
        // errMessage: "",
      };

    case CONNECT_FREE:
      // break;
      localStorage.setItem("isAuthenticated", true);
      localStorage.setItem("token", action.payload.token);
      // const ws = useContext(WebSocketContext);
      // ws.setConnected(true);
      // localStorage.setItem("user", JSON.stringify(action.payload.user));
      return {
        ...state,
        token: action.payload.token, // in payload user and token
        isAuthenticated: true,
        loginTimestamp: Date.now(),
      };

    case LOGOUT_SUCCESS:
      localStorage.setItem("isAuthenticated", false);
      // localStorage.removeItem("token");
      localStorage.removeItem("user");
    case RESET_AUTH_USER:

    case REGISTER_FAIL:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        user: null,
        isAuthenticated: false,
        tokenType: "",
        // isLoading: false,
        // authError: true,
        // errMessage: action.payload,
      };
    default:
      return state;
  }
}
